import { buildUrl } from "@Helpers/api/buildUrl";

/**
 * Builds the Cashier payment confirmation link for the given Stripe payment.
 *
 * @param {String} paymentId The Stripe payment identifier.
 * @param {String} redirectUrl The URL to redirect to after confirmation.
 *
 * @returns The payment confirmation URL.
 */
export default function(paymentId, redirectUrl = window.location.href) {
  const cashierUrl = "/{cashierPath}/payment/{paymentId}?redirect={urlForPlanRedirect}";

  return buildUrl(cashierUrl, {
    cashierPath: window.Spark.cashierPath,
    paymentId,
    urlForPlanRedirect: redirectUrl,
  });
}